import { type Slide, type SlideDTO, SlideEntityType } from './type.d'

export class SlideAdapter implements Slide {
  public id: Slide['id']
  public posterImage: Slide['posterImage']
  public mobilePosterImage: Slide['mobilePosterImage']
  public entityType: Slide['entityType']
  public object: Slide['object']

  constructor(data: SlideDTO) {
    this.id = data.id
    this.posterImage = data.posterImage
    this.mobilePosterImage = data.mobilePosterImage
    this.entityType = data.entity.type
    this.object = this._setSlideObject(data)
  }

  private _setSlideObject(data: SlideDTO): Slide['object'] {
    const getLink = (entityType: SlideEntityType): Slide['object']['link'] => {
      switch (entityType) {
        case SlideEntityType.event: {
          return `/event/${data.entity.object.id}`
        }
      }
    }

    return {
      ...data.entity.object,
      price: data.entity.object?.price ?? 'Распродано',
      buttonText: 'Купить билет',
      link: getLink(data.entity.type)
    }
  }
}
